import { createReducer, on } from "@ngrx/store";
import { addPaises, addPaisesError, updatePais, deletePais, clearPaises,  } from "../actions/paises.actions";
import { initialPaisesState } from "../../core/interfaces/models/pais.interface";

export const paisReducer = createReducer(
  initialPaisesState,
  on(addPaises, (_, { paisesState }) => (
    paisesState
  )),
  on(addPaisesError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updatePais, (state, { pais }) => ({
    ...state,
    paises: state.paises.map(u =>
      u.id === pais.id ? pais : u
    )
  })),
  on(deletePais, (state, { id }) => ({
    ...state,
    paises: state.paises.filter(u => u.id !== id)
  })),

  on(clearPaises, () => initialPaisesState)

)
